import { HierarcicalObjectReference } from "@novorender/data-js-api";
import { useCallback } from "react";

import { useAppDispatch } from "app/redux-store-interactions";
import { useExplorerGlobals } from "contexts/explorerGlobals";
import { hiddenActions, useDispatchHidden } from "contexts/hidden";
import { highlightActions, useDispatchHighlighted } from "contexts/highlighted";
import { renderActions } from "features/render";
import { extractObjectIds } from "utils/objectData";
import { getDescendants, searchByParentPath } from "utils/search";

export function useSelectObject() {
    const {
        state: { db },
    } = useExplorerGlobals();
    const dispatchHighlighted = useDispatchHighlighted();
    const dispatchHidden = useDispatchHidden();
    const dispatch = useAppDispatch();

    return useCallback(
        async ({ obj, abortSignal }: { obj: HierarcicalObjectReference; abortSignal: AbortSignal }) => {
            if (!db) {
                return;
            }

            try {
                await getDescendants({ db, parentNode: obj, abortSignal }).then((ids) => {
                    dispatchHighlighted(highlightActions.add(ids));
                    dispatchHidden(hiddenActions.remove(ids));
                });
            } catch {
                await searchByParentPath({
                    db,
                    abortSignal,
                    parentPath: obj.path,
                    callback: (refs) => {
                        const ids = extractObjectIds(refs);
                        dispatchHighlighted(highlightActions.add(ids));
                        dispatchHidden(hiddenActions.remove(ids));
                    },
                });
            }

            if (!abortSignal.aborted) {
                dispatch(renderActions.setMainObject(obj.id));
                dispatchHighlighted(highlightActions.add([obj.id]));
                dispatchHidden(hiddenActions.remove([obj.id]));
            }
        },
        [db, dispatch, dispatchHighlighted, dispatchHidden],
    );
}
